import * as types from "../mutation-types";
import group from "@/api/group";

export const state = {
  groups: [],
};

export const getters = {
  groups: (state) => Object.values(state.groups),

  getGroupById: (state, getters) => (groupId) =>
    getters["groups"].filter((g) => g.id === groupId)[0],
};

export const mutations = {
  [types.GROUP_SET](state, group) {
    state.groups = { ...state.groups, [group.id]: group };
  },

  [types.GROUPS_SET](state, groups) {
    const data = {};
    groups.forEach((g) => (data[g.id] = g));
    state.groups = data;
  },
};

export const actions = {
  async fetch({ commit, rootGetters }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const { groups } = await group.fetch(rootGetters["user/token"]);

      commit(types.GROUPS_SET, groups);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async create({ commit, rootGetters }, { payload }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const data = await group.create(rootGetters["user/token"], payload);

      commit(types.GROUP_SET, data);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async delete({ commit, rootGetters, getters }, { groupId }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      await group.delete(rootGetters["user/token"], groupId);

      commit(
        types.GROUPS_SET,
        getters["groups"].filter((g) => g.id !== groupId)
      );
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async changeSettings({ commit, rootGetters }, { groupId, payload }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const data = await group.changeSettings(
        rootGetters["user/token"],
        groupId,
        payload
      );

      commit(types.GROUP_SET, data);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async addMember({ commit, rootGetters }, { groupId, payload, isGroup = 0 }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      const data = await group.addGroupOrMember(
        rootGetters["user/token"],
        isGroup,
        groupId,
        payload
      );

      commit(types.GROUP_SET, data);
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },

  async removeMember({ commit, rootGetters, getters }, { groupId, memberId }) {
    try {
      commit(types.INCREMENT_REQUEST, undefined, { root: true });

      await group.removeGroupMember(
        rootGetters["user/token"],
        groupId,
        memberId
      );

      commit(
        types.GROUP_SET,
        getters["groups"]
          .filter((group) => group.id === groupId)
          .map((group) => {
            return {
              ...group,
              members: group.members.filter((m) => m.id !== memberId),
            };
          })[0]
      );
    } finally {
      commit(types.DECREMENT_REQUEST, undefined, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
